// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu13/Item.css
// module id = 2031
// module chunks = 0